import type { RouteObject } from "react-router-dom";

export const surchargeDisputeRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Surcharge disputes" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AdminSurchargeDisputesPage } = await import(
            "./admin-surcharge-disputes-page"
          );
          return { Component: AdminSurchargeDisputesPage };
        },
      },
    ],
  },
];
